<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="do-not-print">
    <div class="row">
        <div class="col-24">
            <h1>My Clients</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button id="btnBack" class="button cancel" (click)="onBack()">Back</button>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <div class="bottom-10">
                <a id="btnPrint" class="link-button link print" (click)="printPDF()">Print</a>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            Data current as of: {{this.wesLastAccessDate}}
        </div>
    </div>
</div>
<div class="printable" id="printable">
    <div class="row">
        <div class="col-16">
            <table class="all-border" id="printArea">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of this.details">
                        <td> {{row.key}} </td>
                        <td> {{row.value}} </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
